import { ReactNode, useId, useState } from "react";
import { Tooltip } from "reactstrap";

interface InfoTooltipProps {
    children: ReactNode;
    placement?: "top" | "bottom" | "left" | "right";
}

// Small info icon that explains the label next to it on hover / focus.
const InfoTooltip = ({ children, placement = "right" }: InfoTooltipProps) => {
    const [isOpen, setIsOpen] = useState(false);
    // useId returns ":r1:", which is not a valid selector for the tooltip target
    const id = `info-${useId().replace(/:/g, "")}`;

    return <>
        <i
            id={id}
            className="bx bx-info-circle text-muted ms-1 align-middle"
            style={{ cursor: "help", fontSize: "1rem" }}
            tabIndex={0}
            aria-label="More information"
        />
        <Tooltip target={id} isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} placement={placement} style={{ textAlign: "left", maxWidth: 340 }}>
            {children}
        </Tooltip>
    </>;
};

export default InfoTooltip;
